const footerAPI = {
    titles: [ {title: "About Nike"},{title: "Get Help"},{title: "Company"} ],
    links: [
      [
        {link: "News"},
        {link: "Careers"},
        {link: "Investors"},
        {link: "Prupose"},
        {link: "Sustainability"},
      ],
      [
        {link: "Order Status"},
        {link: "Shipping & Delivery"},
        {link: "Payment Options"},
        {link: "Gift Card Balance"},
        {link: "Contact Us"},
        {link: "FAQ"},
        {link: "Blog"},
      ],
      [
        {link: "Gift Cards"},
        {link: "Promotions"},
        {link: "Find A Store"},
        {link: "Signup"},
        {link: "Nike Jouneral"},
        {link: "Send Us Feeback"},
      ],
    ]
  };
  
  export {footerAPI};